import { Component } from '@angular/core';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@Component({
  selector: 'modal-processing-status',
  standalone: true,
  imports: [
    MatProgressBarModule,
    MatButtonModule
  ],
  templateUrl: './modal-processing-status.component.html',
  styleUrl: './modal-processing-status.component.scss'
})
export class ModalProcessingStatusComponent {
  header: string;

  constructor (
    public readonly dialogRef: MatDialogRef<ModalProcessingStatusComponent>
  ) {}
}
